<template>
	<v-menu v-bind="$attrs" content-class="floating-rounded-menu-container" v-model="localValue">
		<template v-slot:activator="{ on }">
			<slot name="activator" v-bind="{ on }" />
		</template>
		<slot />
	</v-menu>
</template>

<script>
import VModelMixin from '@/mixins/VModelMixin';
export default {
	name: 'FloatingRoundedMenu',
	mixins: [VModelMixin],
};
</script>
<style lang="scss" scoped>
.floating-rounded-menu-container {
	background: white;
	padding: 6px 0px 2px 0px;
	box-shadow: var(--card-shadow);
	border-radius: var(--border-radius);
}
</style>
